import styled from 'styled-components';
import { useResizeObserver } from '../../../hooks/useResizeObserver';
import { ElementTree } from '../elementTree/ElementTree';

export const ElementsDrawer = ({ searchQuery }: { searchQuery: string }) => {
  const [ref, size] = useResizeObserver<HTMLDivElement>();

  return (
    <Container ref={ref}>
      <ElementTree height={size?.height ? size.height - 20 : undefined} searchQuery={searchQuery} />
    </Container>
  );
};

const Container = styled.div`
  box-sizing: border-box;
  width: 100%;
  height: calc(100% - 20px);

  display: flex;
  flex-direction: column;
  justify-content: center;
`;